module.exports = __webpack_public_path__ + "static/img/sm.e35e5c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sm.png
// module id = +6P8
// module chunks = 63